import update from 'immutability-helper';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { move } from 'ramda';

import {
  Typography,
  Box,
  IconButton, Button,
} from '@material-ui/core';

import {
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@material-ui/icons';

import DirectoryProfileItem from '@pro/web-common/components/directory-profile-item';
import SortableList from '@pro/web-common/components/sortable-list';
import SortableListItem from '@pro/web-common/components/sortable-list-item';


const DirectoryItem = React.memo(({ directoryName, profiles, profilesList, onEdit, onDelete, onProfilesUpdate, onEditProfile, onAddProfile }) => {
  const onProfilesSortEnd = useCallback(({ oldIndex, newIndex }) => {
    const newProfiles = move(oldIndex, newIndex, profiles);

    onProfilesUpdate(newProfiles);
  }, [profiles, onProfilesUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  const onProfileDelete = useCallback((index) => {
    const newProfiles = update(profiles, { $splice: [[index, 1]] });

    onProfilesUpdate(newProfiles);
  }, [profiles, onProfilesUpdate]);

  return (
    <Box
      width="100%"
    >
      <Box
        display="flex"
        flex={1}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        pt={1 / 2}
        pb={1 / 2}
      >
        <Typography>
          {directoryName}
        </Typography>

        <Box>
          <IconButton onClick={onEdit}>
            <EditIcon />
          </IconButton>

          <IconButton onClick={onDelete}>
            <DeleteIcon color="secondary" />
          </IconButton>
        </Box>
      </Box>

      <Box
        display="flex"
        flex={1}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        pt={1 / 2}
        pb={1 / 2}
        ml={3}
      >
        <SortableList
          onSortEnd={onProfilesSortEnd}
          useDragHandle
          lockAxis="y"
        >
          {profiles.filter((profileId) => profilesList[profileId]).map((profileId, index) => (
            <SortableListItem
              key={index} // eslint-disable-line react/no-array-index-key
              index={index}
            >
              <DirectoryProfileItem
                onEdit={() => onEditProfile(profileId)}
                onDelete={() => onProfileDelete(index)}
                {...profilesList[profileId]}
              />
            </SortableListItem>
          ))}
        </SortableList>
      </Box>

      <Box
        mt={1}
        textAlign="right"
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onAddProfile}
        >
          Add Profile
        </Button>
      </Box>
    </Box>
  );
});


DirectoryItem.propTypes = {
  directoryName: PropTypes.string.isRequired,
  profiles: PropTypes.arrayOf(PropTypes.string),
  profilesList: PropTypes.shape({}),
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onProfilesUpdate: PropTypes.func.isRequired,
  onEditProfile: PropTypes.func.isRequired,
  onAddProfile: PropTypes.func.isRequired,
};

DirectoryItem.defaultProps = {
  profiles: [],
  profilesList: {},
};


export default DirectoryItem;
